module.exports = __webpack_public_path__ + "static/media/digitalhouse.63756b92.png";